import React from 'react';
import styled from 'styled-components';
import _BikeCard from 'components/_cards/BikeCard/BikeCard';
import RichText from 'components/_utility/RichText/RichText';
import Button from '../Button/Button';
import { minBp } from '../../lib/theme';

export const Wrap = styled.div`
  margin: 20px 0 0;
  position: relative;

  ${({ hasButton }) =>
    hasButton
      ? `
    margin: 20px 0 60px;
  `
      : ``}

  @media ${minBp('tabletLarge')} {
    margin: 0 0 60px;
  }
`;

export const About = styled.div`
  z-index: 2;
  height: 100%;
  width: 100%;
  padding: 20px 30px 10px;

  @media ${minBp('tabletLarge')} {
    position: absolute;
    height: 576px;
    width: 460px;
    padding: 70px 100px 0 100px;
    background: white;
    overflow: hidden;
  }
`;

export const Hairline = styled.div`
  width: 1px;
  background: #f1f1f1;
  height: 504px;
  position: absolute;
  top: 20px;
  right: 0;
`;

export const Description = styled(RichText)`
  line-height: 1.375;
  display: none;

  @media ${minBp('tabletLarge')} {
    display: block;
  }
`;

export const Bikes = styled.div`
  height: 544px;
  margin-top: -20px;

  @media ${minBp('tabletLarge')} {
    margin-top: 0;
  }

  .ScrollbarsCustom {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .ScrollbarsCustom-Wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 10px;
    right: 0px;
    overflow: hidden;
  }

  .ScrollbarsCustom-Scroller {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    overflow: scroll hidden;
    margin-bottom: -15px;
  }

  .ScrollbarsCustom-Content {
    box-sizing: border-box;
    padding: 0.05px;
    min-height: 100%;
    min-width: 100%;
  }

  .ScrollbarsCustom-Track.ScrollbarsCustom-TrackX {
    position: absolute;
    overflow: hidden;
    border-radius: 4px;
    background: #dddddd;
    user-select: none;
    height: 10px;
    bottom: 20px;
    left: 30px;
    width: calc(100% - 60px);

    @media ${minBp('tabletLarge')} {
      width: calc(100% - 532px);
      bottom: 0px;
      left: 498px;
    }
  }

  .ScrollbarsCustom-Thumb.ScrollbarsCustom-ThumbX {
    touch-action: none;
    cursor: pointer;
    border-radius: 4px;
    background: #585a5f;
    height: 100%;
    width: 1245.69px;
    transform: translateX(0px);
  }
`;

export const BikeScroller = styled.div`
  ${({ cardCount = 0 }) => `
    display: -ms-grid;
    display: grid;
    padding: 30px 30px 20px;
    grid-gap: 32px;
    grid-auto-flow: column;
    grid-auto-rows: 464px;
    grid-auto-columns: 259px;
    -ms-grid-columns: (259px)[${cardCount}];

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      display: flex;
    }

    @media ${minBp('additional.mobile')} {
      grid-auto-columns: 271px;
      -ms-grid-columns: (271px)[${cardCount}];
    }

    @media ${minBp('tabletLarge')} {
      padding: 40px 40px 0 40px;
      padding-left: 500px;
    }
  `}
`;

export const Gutter = styled.div`
  width: 1px;
`;

export const BikeCard = styled(_BikeCard)`
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    min-width: 271px;
    width: 271px;
    max-width: 271px;
    margin-right: 32px;
  }
`;

export const ViewButton = styled(Button)`
  margin-top: 15px;
  background-color: ${({ theme }) => theme.colors.buttons.default};
  color: white;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-size: 17px;
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;
  position: absolute;
  bottom: 0px;
  z-index: 1;

  @media ${minBp('tabletLarge')} {
    position: static;
    bottom: auto;
  }

  ${({ variant, theme }) => {
    if (variant === 'btn--style-y') {
      return `
        background-color: ${theme.colors.buttons.racingYellow};
        color: black;
        
        &:hover:not(:disabled) {
          background-color: ${theme.colors.buttons.racingYellowDark};
          border-color: ${theme.colors.buttons.racingYellow};
          outline-color: ${theme.colors.buttons.racingYellowDark};
          color: black;
        }
        
        &:focus {
          background-color: ${theme.colors.buttons.racingYellow};
          border-color: ${theme.colors.buttons.racingYellowDark};
          color: white;
        }
      `;
    }
  }}
`;

export const Title = styled.h3`
  text-transform: uppercase;
  font-size: 24px;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-weight: 500;
  margin-bottom: 7px;

  @media ${minBp('tabletLarge')} {
    font-size: 35px;
    margin-bottom: 15px;
  }
`;
